import { useStateManager } from "@bcm-dev/bcms-vite";
import React from "react";
import "./styles.css";

/**
 * @function TASPositivePayCreateTemplateFileMappingPreviewMobileTable
 * @return {React.Component}
 * @exported true
 * @description Mobile import file mapping preview mobile table for the ImportFileMappingPreviewWidget.
 */
export default function TASPositivePayCreateTemplateFileMappingPreviewMobileTable(props) {
    const { data } = useStateManager();
    
    // Only show the first file row.
    const firstFileRow = data.checkTemplateRows[0];
    const fileRows = firstFileRow ? [ firstFileRow ] : [];
    const columns = data.selectedColumns;

    const columnLabels = columns.reduce((acc, item) => {
        var optionName = item.value.value.replace("(Required)", "").trimEnd();

        // The column name is different for selection "Item Type Code".
        if(optionName === "Item Type Code") optionName = "Item Type Custom";

        acc.push({ value: optionName });
        return acc;
    }, []);

    const rows = fileRows.reduce((acc, item, i) => {
        acc.push(
            <React.Fragment key="0">
                <TASPositivePayCreateTemplateFileMappingPreviewMobileTableRow participant={ item } columnLabel={ columnLabels[0].value } columnText={ item.checkDate } />
                <TASPositivePayCreateTemplateFileMappingPreviewMobileTableRow participant={ item } columnLabel={ columnLabels[1].value } columnText={ item.checkNumber } />
                <TASPositivePayCreateTemplateFileMappingPreviewMobileTableRow participant={ item } columnLabel={ columnLabels[2].value } columnText={ item.business } />
                <TASPositivePayCreateTemplateFileMappingPreviewMobileTableRow participant={ item } columnLabel={ columnLabels[3].value } columnText={ item.accountNumber } />
                <TASPositivePayCreateTemplateFileMappingPreviewMobileTableRow participant={ item } columnLabel={ columnLabels[4].value } columnText={ item.accountNickname } className="" />
                <TASPositivePayCreateTemplateFileMappingPreviewMobileTableRow participant={ item } columnLabel={ columnLabels[5].value } columnText={ item.payee } className="" />
                <TASPositivePayCreateTemplateFileMappingPreviewMobileTableRow participant={ item } columnLabel={ columnLabels[6].value } columnText={ item.amount } className="" />
                <TASPositivePayCreateTemplateFileMappingPreviewMobileTableRow participant={ item } columnLabel={ columnLabels[7].value } columnText={ item.status } className="last-row" />
            </React.Fragment>
        );
        return acc;
    }, []);

    return (
        <div className="tas-positive-pay-create-template-file-mapping-preview-mobile-table">
            { rows }
        </div>
    );
}

/**
 * @function ImportFileMappingPreviewMobileTableRow
 * @return {React.Component}
 * @exported false
 * @description Mobile import file mapping preview mobile table row for the ImportFileMappingPreviewMobileTable.
 */
function TASPositivePayCreateTemplateFileMappingPreviewMobileTableRow(props) {
    const className = props.className ?? "";
    const columnLabel = props.columnLabel ?? "(Exclude Column)";
    const columnText = props.columnText ?? "[columnText]";

    return (
        <div className={`tas-positive-pay-create-template-file-mapping-preview-mobile-table-row ${className}`}>
            <div className="flex-container align-center column-container">
                <div className="set-width">
                    <span className="column-label">{ columnLabel }:</span>
                </div>
                <div className="set-width">
                    <span className="column-text">{ `"${ columnText }"` }</span>
                </div>
            </div>
        </div>
    );
}